export default __webpack_public_path__ + "static/media/imgBoatFinish.20c799ef.png";